<template>
  <div id="ContactUs">
    <Head />
    <div class="contact">
      <div class="info">
        <div class="title">
          联系我们
          <img src="../assets/contact/组 15.png" />
        </div>
        <div class="msg">
          <p>中国煤炭工业协会</p>
          <p>
            联系电话
            <span>:</span>(010)64463365
          </p>
          <p>
            传真
            <span>:</span>(010)64463614
          </p>
          <p>
            电子邮箱
            <span>:</span>glcxcg@163.com
          </p>
          <p>
            通讯地址
            <span>:</span>北京市朝阳区和平街十三区煤炭大厦（100013）
          </p>
          <!-- <p>
            邮编
            <span>:</span>100013
          </p> -->
        </div>
      </div>
      <div class="map">
        <div class="amap-page-container">
          <el-amap
            vid="amap"
            :center="center"
            :zoom="zoom"
            :plugin="plugin"
            class="amap-demo"
          >
            <el-amap-marker
              vid="component-marker"
              :position="center"
              :content-render="center"
            ></el-amap-marker>
            <el-amap-marker
              v-for="(marker, index) in markers"
              :key="index"
              :position="marker.position"
              :events="marker.events"
              :visible="marker.visible"
              :draggable="marker.draggable"
              :vid="index"
            ></el-amap-marker>
          </el-amap>
        </div>
      </div>
    </div>
    <RightNav />
    <Foot />
  </div>
</template>
<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
import RightNav from "../components/RightNav";
export default {
  data() {
    // const self = this;
    return {
      center: [116.425713, 39.962491],
      zoom: 15,
      lng: 0,
      lat: 0,
      loaded: false,
      markers: [
        {
          position: [116.425713, 39.962491],
          events: {
            // click: () => {
            //   alert("click marker");
            // },
            dragend: (e) => {
              console.log("---event---: dragend");
              this.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
            },
          },
          visible: true,
          draggable: false,
          template: "<span>1</span>",
        },
      ],
      plugin: [
        {
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 100, //超过10秒后停止定位，默认：无穷大
          maximumAge: 0, //定位结果缓存0毫秒，默认：0
          convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true, //显示定位按钮，默认：true
          buttonPosition: "RB", //定位按钮停靠位置，默认：'LB'，左下角
          showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
          extensions: "all",
          pName: "Geolocation",
          // events: {
          //   init(o) {
          //     // o 是高德地图定位插件实例
          //     o.getCurrentPosition((status, result) => {
          //       console.log(result);
          //       if (result && result.position) {
          //         self.lng = result.position.lng;
          //         self.lat = result.position.lat;
          //         self.center = [self.lng, self.lat];
          //         self.loaded = true;
          //         self.$nextTick();
          //       }
          //     });
          //   }
          // }
        },
      ],
    };
  },
  components: {
    Head,
    Foot,
    RightNav,
  },
  mounted() {
    console.log(window.sessionStorage.id); //可以获取到经纬度
  },
};
</script>
<style lang="less" scoped>
#ContactUs {
  min-height: 100%;
  .contact {
    padding: 0 1.35rem;
    margin-top: 0.76rem;
    display: flex;
    justify-content: space-between;
    .info {
      .title {
        font-size: 0.28rem;
        margin-bottom: 0.49rem;
        img {
          position: relative;
          top: 0.1rem;
          left: 0.18rem;
        }
      }
      .msg {
        // width: 467px;
        height: 257px;
        font-size: 0.19rem;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        span {
          margin-right: 0.1rem;
        }
      }
    }
    .map {
      // float: right;
      .amap-demo {
        width: 10.49rem;
        height: 4.08rem;
      }
    }
  }
}
</style>
